var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldBoolean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4h-1v16h1V4zm3.248 8.475c0 2.343.913 3.691 2.5 3.691 1.582 0 2.49-1.338 2.49-3.677 0-2.334-.923-3.7-2.49-3.7-1.577 0-2.5 1.361-2.5 3.686zM5.579 9.93V16h.879V8.954h-.874l-1.875 1.348v.928l1.792-1.3h.078zm12.169 5.468c1.04 0 1.607-1.035 1.607-2.924 0-1.87-.577-2.915-1.607-2.915s-1.616 1.054-1.616 2.915c0 1.884.576 2.924 1.616 2.924z",
    fill: "currentColor"
  })));
}
export default SvgFieldBoolean;